import React, { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../../../../app/hooks'
import { InitState } from '../../../../../../redux/reducers/root/initialState'
import { OnFieldChangeType } from '../../../../../../@types/types'

const styles = {
  editButton: {
    background: 'var(--color-background-default)',
    border: '1px solid var(--color-border-weak)',
    borderRadius: '10px',
    height: '40px',
    width: '40px',
  },
}
interface ReadOnlyContactInfoProps {
  setIsReadOnlyMode: Dispatch<SetStateAction<boolean>>
  onChange: OnFieldChangeType
}
const ReadOnlyContactInfo: React.FC<ReadOnlyContactInfoProps> = ({ setIsReadOnlyMode, onChange }) => {
  const { insertionData } = useAppSelector((state: InitState) => state.insertionFeature)
  const { phoneNumber: phoneNumberFromUser } = useAppSelector((state: InitState) => state.userFeature)
  const { t } = useTranslation()
  const handleTextLinkClick = () => {
    if (insertionData.phoneNumber) {
      onChange({ screen: 'contactInfo', property: 'phoneNumber' }, undefined)
    } else if (phoneNumberFromUser) {
      onChange({ screen: 'contactInfo', property: 'phoneNumber' }, phoneNumberFromUser)
    } else {
      setIsReadOnlyMode(false)
    }
  }
  return (
    <>
      <div data-testid='readonly-contact-info-container' className='one-whole grid grid-item grid-fill-rows grid-flex'>
        <div className='grid-item'>
          <p>
            <span id='first-name' className={'pii-hide'}>
              {insertionData.firstName}
            </span>
            &nbsp;
            <span id='last-name' className={'pii-hide'}>
              {insertionData.lastName}
            </span>
          </p>
          <p id={'email'} className={'pii-hide'}>
            {insertionData.email}
          </p>
          {insertionData.phoneNumber && <p className={'pii-hide'}>{insertionData.phoneNumber}</p>}
        </div>
        <div className='with-icon grid-item grid-align-start grid-item-fixed-width'>
          <button
            id='contact-data-edit-button'
            data-testid='contact-data-edit-button'
            className='float-right align-center'
            style={styles.editButton}
            onClick={() => setIsReadOnlyMode(false)}
          >
            <i className='is24-icon-edit font-heading-medium-regular' />
          </button>
        </div>
      </div>
      <div>
        <button
          id='add-extra-field-button'
          className={`link-text border-none background-none padding-horizontal-none padding-top-s`}
          onClick={handleTextLinkClick}
        >
          {!insertionData.phoneNumber && (
            <span data-testid='add-phone-link-text'>
              <i className='is24-icon-password-show' /> {t('wizard.screen.contactInfo.labels.addPhoneNumberField')}
            </span>
          )}
          {insertionData.phoneNumber && (
            <span>
              <i className='is24-icon-eye-slash' /> {t('wizard.screen.contactInfo.labels.removePhoneNumberField')}
            </span>
          )}
        </button>
      </div>
    </>
  )
}

export default ReadOnlyContactInfo
